import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-reset-password-success',
	imports: [RouterLink],
	template: `
		<div class="container mt-5">
			<div class="row justify-content-center">
				<div class="col-md-6 text-center">
					<h2>Votre mot de passe a été modifié</h2>
					<p>Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.</p>
					<a routerLink="/login" class="btn btn-primary">Se connecter</a>
				</div>
			</div>
		</div>
	`,
})
export class ResetPasswordSuccessComponent {}